export function TextHorizontal({ label, text }) {
  return (
    <div className="row mb-3">
      <div className="col-sm-3 col-form-label fw-bold">{label}</div>
      <div className="col-sm-9 d-flex align-items-center">{text}</div>
    </div>
  );
}
